import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";

@Component({
  selector: "text-area-input-element",
  templateUrl: "./text-area-input-element.component.html",
  styleUrls: ["./text-area-input-element.component.scss"],
})
export class TextAreaInputElementComponent implements OnInit, OnChanges {
  @Input() label;
  @Input() rows;
  @Input() maxChars;
  @Input() value;
  @Input() defaultRestoredValue;
  @Input() hasExternalError;
  @Input() smallMargin;

  @Output() textAreaUpdated = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  ngOnChanges(change) {
    if (change.defaultRestoredValue && this.defaultRestoredValue) {
      this.value = this.defaultRestoredValue;
    }
  }

  checkIfOverMaxChars() {
    return this.value && this.value.length > parseInt(this.maxChars);
  }

  update(value) {
    this.textAreaUpdated.emit(value);
  }
}
